import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class TipoSeguimiento extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'tipo-seguimiento/one', saveUrl: 'tipo-seguimiento/save', backUrl: '/Catalogo/TiposSeguimientos' },
      new Form([
        Form.Field('text', 'tipo_seguimiento_guia', 'Descripcion', '', [Validators.required], 12),
      ], ['Guardar'], 'Tipos Seguimiento'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(TipoSeguimiento)
